/** @format */

import type { ReactNode } from "react";
import { createContext } from "react";
import { websocketManager } from "./websocketManager";

interface WebSocketContextValue {
  manager: typeof websocketManager;
}

// Persist context across Vite HMR to prevent provider/consumer mismatch
const WebSocketContext =
  (import.meta.hot?.data?.WebSocketContext as ReturnType<
    typeof createContext<WebSocketContextValue | null>
  >) ?? createContext<WebSocketContextValue | null>(null);

if (import.meta.hot?.data) {
  import.meta.hot.data.WebSocketContext = WebSocketContext;
}

interface WebSocketProviderProps {
  children: ReactNode;
}

export const WebSocketProvider = ({ children }: WebSocketProviderProps) => {
  return (
    <WebSocketContext.Provider value={{ manager: websocketManager }}>
      {children}
    </WebSocketContext.Provider>
  );
};
